<template>
  <div
          :style="customStyle"
          class="sedna-slider-app"
          :class="{ aretv: isAretv }"
  >
    <div id="rssNewsFeed">
      <div class="newsLogo">
        <div class="areLogo">
          <img :src="`/img/are_logo.svg`"/>
        </div>
        <div class="newsTitle">
          <fit-text
                  :input-text="title"
                  :preview-options="previewOptions">

          </fit-text>
        </div>
      </div>
      <Slider class="news-slider" :items="entries" v-if="!isEmptyAndLoading"/>
    </div>
  </div>
</template>

<script>
  import {format} from "date-fns";
  import Slider from "./Slider";
  import Parser from "rss-parser";
  import FitText from "./FitText";


  export default {
    name: "RssFeeds",
    components: {Slider, FitText},
    props: {
      customStyle: {
        type: Object, default: () => {
        }
      },
      customColor: {type: String, default: ""},
      customBackground: {type: String, default: ""},
      isAretv: {type: Boolean, default: true}
    },
    data: function () {
      return {
        isLoading: false,
        entries: [],
        is4k: false,
        refreshTimer: null,
        title: "News",
        previewOptions: {
          safeWidth: 512,
          previewHeight: 265,
          previewVertOffset: 0,
          originalFontSize: 265
        }
      };
    },
    computed: {
      isEmptyAndLoading() {
        return this.isLoading && this.entries.length === 0;
      }
    },
    methods: {
      refreshFeeds() {
        // Roll with defaults
        const CORS_PROXY_URL = "https://cors-proxy.advent.zone/";
        const parser = new Parser();
        let urls = [
          "https://feeds.a.dj.com/rss/RSSOpinion.xml",
          "https://feeds.a.dj.com/rss/RSSWorldNews.xml",
          "https://feeds.a.dj.com/rss/WSJcomUSBusiness.xml",
          "https://feeds.a.dj.com/rss/RSSMarketsMain.xml",
          "https://feeds.a.dj.com/rss/RSSWSJD.xml",
          "https://feeds.a.dj.com/rss/RSSLifestyle.xml"
        ];

        // ...unless some URLs are provided from the outside
        const urlQuery = new URLSearchParams(window.location.search);
        if (urlQuery.get("feeds") !== null) {
          urls = urlQuery.get("feeds").split(",");
        }

        // Handle title
        if (urlQuery.get("title") !== null) {
          this.title = urlQuery.get("title");
        }

        // eslint-disable-next-line
        console.log("Feed URLs:");
        // eslint-disable-next-line
        console.table(urls);

        const parsers = urls.map(url => parser.parseURL(CORS_PROXY_URL + url));

        this.isLoading = true;

        Promise.all(parsers).then(fetchedFeeds => {
          // for each downloaded feed
          this.entries = fetchedFeeds.reduce((entries, feedData) => {
            // for each feed item
            const feedItems = feedData.items.map(item => {
              return {
                // add source title and formatted timestamp
                ...item,
                sourceTitle: feedData.title,
                timestamp: format(new Date(item.pubDate), "MMMM do")
              };
            });
            return entries.concat(feedItems);
          }, []);
          this.isLoading = false;
        });
      },
      displayRes() {
        if (window.innerWidth >= 3839)
          return true
        return false
      }
    },
    created() {
      this.is4k = this.displayRes();
      this.previewOptions.originalFontSize = this.is4k ? 530 : 265
      this.refreshFeeds();
      this.refreshTimer = setInterval(this.refreshFeeds, 30 * 60 * 1000); // refresh news every 30 mins
    }
  };
</script>

<style>
  .title {
    /*font-size: 265px;*/
    /*height: 265px;*/
  }

  #rssNewsFeed {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  @media screen and (max-width: 3839px) {
    .sedna-slider-app {
      width: 1920px;
      height: 1080px;
      padding: 115px 115px 70px 115px;
    }

    .news-slider, .slide, .slideTitle {
      padding-bottom: 50px;
    }

    .sedna-slider-app h2 {
      font-size: 78px;
      margin: 0;
      line-height: 100px;
      font-weight: normal;
      font-family: "Avenir Next LT Pro", Helvetica, sans-serif;
    }

    .sedna-slider-app h1 {
      font-size: 264px;
      font-weight: normal;
      display: inline;
      font-family: "Avenir Next LT Pro", Helvetica, sans-serif;
    }

    .newsTitle {
      width: 100%;
      padding: 0;
      height: 265px;
      margin: 0;
      display: flex;
      text-transform: uppercase;
      font-family: "AvenirNext LT Pro", Helvetica, sans-serif;
    }

    .news .news-bar {
      width: 100px;
      height: 5px;
      background-color: white;
      margin-left: 25px;
      border-radius: 25px;
      align-self: center;
    }


  }

  @media screen and (min-width: 3840px) {
    .sedna-slider-app {
      width: 3840px;
      height: 2160px;
      padding: 230px 230px 140px 230px;
    }

    .sedna-slider-app h2 {
      font-size: 156px;
      margin: 0;
      line-height: 200px;
      font-weight: normal;
      font-family: "Avenir Next LT Pro", Helvetica, sans-serif;
    }

    .sedna-slider-app h1 {
      font-size: 528px;
      font-weight: normal;
      display: inline;
      font-family: "Avenir Next LT Pro", Helvetica, sans-serif;
    }

    .newsTitle {
      font-size: 530px;
      text-transform: uppercase;
      font-family: "AvenirNext LT Pro", Helvetica, sans-serif;
      width: 100%;
      margin:0;
      padding:0;
      height: 530px;
      display: flex;
    }

    .news .news-bar {
      width: 200px;
      height: 10px;
      background-color: white;
      margin-left: 50px;
      border-radius: 50px;
      align-self: center;
    }

    .news-slider, .slide, .slideTitle {
      padding-bottom: 100px;
    }


  }
</style>
